import SearchBox from '../../../../UtilComponent/level_1/SearchBox'
import SortBox from './SortBox'

type Props = {
  searchWord: any
  setSearchWord: any
  selectedSort: any
  setSelectedSort: any
  options: any
  isAsc: any
  setIsAsc: any
}

const FilterBoxTop = (props: Props) => {
  const { searchWord, setSearchWord, selectedSort, setSelectedSort, options, isAsc, setIsAsc } = props

  return (
    <div className="switcher text-small">
      <SearchBox
        state={searchWord}
        setState={setSearchWord}
        placeholder="連絡先を検索"
      />
      <SortBox selectedSort={selectedSort} setSelectedSort={setSelectedSort} options={options} isAsc={isAsc} setIsAsc={setIsAsc} />
      <span></span>
    </div>
  )
}

export default FilterBoxTop
